<template>
  <div v-if="articles.length" class="article-slider">
    <h2 class="title">{{ title }}</h2>

    <SvoiSwiper :items="swiperItems" :responsive="responsive" class="custom-swiper">
      <template #item="{ item }">
        <ArticleCardView :article="item.article" />
      </template>

      <template #controls="{ swipeSteps }">
        <div class="control -left" @click="swipeSteps(-1)">
          <BaseIconSvoi icon="arrow/arrow-left-2" />
        </div>
        <div class="control -right" @click="swipeSteps(1)">
          <BaseIconSvoi icon="arrow/arrow-right-3" />
        </div>
      </template>
    </SvoiSwiper>
  </div>
</template>

<script lang="ts" setup>
  import { SvoiSwiper } from '@svoi-ui/components/swiper'
  import { BaseIconSvoi } from '~/components/base-ui/icon'
  import ArticleCardView from './ArticleCard.vue'
  import type { ArticleCard } from '~/models/articles'

  const props = defineProps<{
    title: string
    articles: ArticleCard[]
  }>()

  const swiperItems = computed(() => props.articles.map(article => ({ id: article.id, article })))

  const responsive = [
    { countVisible: 1, minWidth: 0, maxWidth: 530, gap: 16 },
    { countVisible: 2, minWidth: 531, maxWidth: 900, gap: 20 },
    { countVisible: 3, minWidth: 900, gap: 24 },
  ]
</script>

<style lang="scss" scoped>
  .article-slider {
    @extend %flex-column;

    width: 100%;
    position: relative;
    gap: 32px;

    @include vp-1279 {
      gap: 24px;
    }

    @include vp-767 {
      gap: 16px;
    }

    > .title {
      font-size: 32px;
      font-weight: 500;
      line-height: 40px;

      @include vp-767 {
        font-size: 24px;
        line-height: 32px;
      }
    }

    > .custom-swiper {
      position: static;

      :deep() {
        .svoi-base-swiper {
          position: static;
        }
      }
    }

    .control {
      position: absolute;
      cursor: pointer;
      background-color: $color-default-white;
      padding: 12px;
      top: 0;
      bottom: 0;
      margin: auto;
      border-radius: 50%;
      height: 48px;
      width: 48px;
      box-shadow: 0 4px 20px 0 rgb(0 0 0 / 8%);
      z-index: 5;

      @include vp-767 {
        display: none;
      }
    }

    .-left {
      left: -24px;
    }

    .-right {
      right: -24px;
    }
  }
</style>
